import PropTypes from "prop-types";
import {
  stringToTicketPhase,
  TicketPhase,
  TicketStatus,
} from "../../assets/js/AppTicketConstant";
import { Button } from "@nextui-org/button";
import React from "react";
import AppUserProfile from "../../assets/js/AppUserProfile";

const ApproverActionButton = ({
  ticketPhase,
  ticketStatus,
  onApproveAll,
  ticketSequenceApproved,
}) => {
  const userId = AppUserProfile.getData()["user_id"];

  const isInvalidApprover =
    ticketSequenceApproved.next_approver_user_id !== Number(userId);
  const isInvalidStatus =
    ticketStatus === TicketStatus.Rejected.value ||
    ticketStatus === TicketStatus.Approved.value ||
    ticketStatus === TicketStatus.Cancelled.value;

  const isDisableRoleAction = isInvalidApprover || isInvalidStatus;

  const approveAllButton = (options = {}) => {
    const { title, bgColor } = options;

    return (
      <Button
        onPress={onApproveAll}
        className={`${bgColor ?? "bg-complete"} !text-white`}
        isDisabled={isDisableRoleAction}
      >
        {title ?? "อนุมัติทั้งหมด"}
      </Button>
    );
  };

  const buildPhaseActionButton = () => {
    switch (stringToTicketPhase(ticketPhase)) {
      case TicketPhase.Proposal:
        return approveAllButton();
      case TicketPhase.Claim:
        return approveAllButton();
      case TicketPhase.Management:
        return approveAllButton();
      case TicketPhase.Accounting:
        return approveAllButton({
          title: "ยืนยันการตรวจสอบงบทั้งหมด",
          bgColor: "bg-blue-500",
        });
      default:
        break;
    }
  };

  return buildPhaseActionButton();
};

ApproverActionButton.propTypes = {
  ticketPhase: PropTypes.string,
  ticketStatus: PropTypes.string,
  onApproveAll: PropTypes.func,
  ticketSequenceApproved: PropTypes.object.isRequired,
};

export default ApproverActionButton;
